import { FiThumbsUp } from "react-icons/fi";
import api from "../../utils/api";
import PostReplies from "./PostReplies";
import { useState, useEffect } from "react";

export default function PostCommentItem({
  data,
  currentUser,
  onAction,
}) {
  const [loading, setLoading] = useState(false);
  const [likes, setLikes] = useState(data.likesCount || 0);
  const [liked, setLiked] = useState(data.isLiked || false);

  /* ================= SYNC WITH PARENT ================= */

  useEffect(() => {
    setLikes(data.likesCount || 0);
    setLiked(data.isLiked || false);
  }, [data.likesCount, data.isLiked]);

  /* ================= HANDLE LIKE ================= */

  const handleLike = async () => {
    if (!currentUser || loading) return;

    const previousLiked = liked;
    const previousLikes = likes;

    try {
      setLoading(true);

      // Optimistic update
      const newLiked = !previousLiked;
      setLiked(newLiked);
      setLikes((prev) =>
        newLiked ? prev + 1 : Math.max(prev - 1, 0)
      );

      const res = await api.post(
        `/api/comments/${data._id}/like`
      );

      // Sync with backend if provided
      if (res.data?.likesCount !== undefined) {
        setLikes(res.data.likesCount);
      }

      if (res.data?.isLiked !== undefined) {
        setLiked(res.data.isLiked);
      }

      // Optional refresh
      if (onAction) onAction();

    } catch (err) {
      console.error("Comment like failed:", err);

      // Rollback
      setLiked(previousLiked);
      setLikes(previousLikes);

    } finally {
      setLoading(false);
    }
  };

  /* ================= AVATAR ================= */

  const avatar =
    data.user?.avatar ||
    `https://ui-avatars.com/api/?name=${encodeURIComponent(
      data.user?.name || "User"
    )}&background=1877f2&color=fff`;

  /* ================= RENDER ================= */

  return (
    <div className="comment-item">

      {/* Avatar */}
      <img
        src={avatar}
        alt="avatar"
        className="comment-avatar"
      />

      {/* Content */}
      <div className="comment-content">

        <div className="comment-name">
          {data.user?.name || "User"}
        </div>

        <div className="comment-text">
          {data.text}
        </div>

        <div className="comment-actions">

          <button
            type="button"
            onClick={handleLike}
            disabled={!currentUser || loading}
            className={`comment-like-btn ${liked ? "liked" : ""}`}
          >
            <FiThumbsUp size={14} />
            {likes > 0 && <span>{likes}</span>}
          </button>

        </div>

        {/* Replies (only root comment) */}
        {!data.parentId && (
          <PostReplies
            parentId={data._id}
            postId={data.postId}
            currentUser={currentUser}
          />
        )}

      </div>
    </div>
  );
}
